import { AttrField, BelongsToField, HasManyByField, NumberField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import UserPersonalInfo from '@/data/models/domain/UserPersonalInfo'
import { ScheduledEmailStatus, ScheduledEmailType } from '@/data/repositories/domain/scheduledEmail/types'
import type FollowUpDetails from '@/data/models/domain/FollowUpDetails'
import type FollowUp from '@/data/models/domain/FollowUp'
import Label from '@/data/models/domain/Label'
import { TmArrayStringField } from '@/data/utils/types'
import type { ModelRaw } from '@/types'

@OrmModel(modelNames.SCHEDULED_CAMPAIGN)
export default class ScheduledEmail<
  T extends ModelRaw<FollowUpDetails> | null = ModelRaw<FollowUpDetails> | null,
> extends BaseModel {
  @StringField()
  public status: ScheduledEmailStatus

  @NumberField(null)
  public emailSenderId: number | null

  @StringField()
  public sendingTimezone: string

  @StringField()
  public startAt: string

  @AttrField()
  public endAt: string | null

  @StringField()
  public nextSendAt: string

  @StringField()
  public createdById: string

  @BelongsToField(UserPersonalInfo, 'createdById')
  public createdBy: UserPersonalInfo

  @StringField()
  public type: ScheduledEmailType

  @StringField()
  public fromName: string

  @StringField()
  public fromEmail: string

  @StringField()
  public replyToEmail: string

  @StringField()
  public subject: string

  @StringField()
  public html: string

  @NumberField()
  public recipientsCount: number

  @AttrField()
  public rrule: string | null

  @StringField()
  public createdAt: string
  /**
   * Follow up info for auto created scheduled email
   */

  @AttrField()
  public followUpDetails: T

  @AttrField()
  private followUp: ModelRaw<FollowUp> | null

  @TmArrayStringField()
  public labelIds: string[]

  @HasManyByField(Label, 'labelIds')
  public labels: Label[]

  public get canBeEdit() {
    return this.status === ScheduledEmailStatus.Paused || this.status === ScheduledEmailStatus.New
  }

  public get isBulk() {
    return this.recipientsCount > 1
  }

  public get isScheduledOnce() {
    return this.type === ScheduledEmailType.Once
  }

  public get relatedFollowUp() {
    return this.followUp
  }

  public isFollowUpScheduledEmail(): this is ScheduledEmail<ModelRaw<FollowUpDetails>> {
    return !!this.followUpDetails
  }
}
